<template>
  <div
    class="flex shrink-0 flex-col divide-y divide-border border-border empty:hidden"
    :class="[
      (edge === 'top' || edge === 'both') && `border-t`,
      (edge === 'bottom' || edge === 'both') && `border-b`,
    ]"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    edge?: "top" | "bottom" | "both";
  }>(),
  {
    edge: "both",
  }
);
</script>
